<template>
  <div class="ace-feed-step-1 ace-content">
    <h2 class="ace-feed-step-1__title">
      Please choose a diet type
    </h2>
    <ButtonGroup class="ace-feed-step-1__buttons">
      <Button
        v-for="(dietType, index) in dietTypes"
        :key="index"
        variant="image"
        :images="dietType.images"
        :text="dietType.title"
        @click="$emit('setDietType', dietType.name)"
      />
    </ButtonGroup>
  </div>
</template>

<script>
import ButtonGroup from '../Layout/ButtonGroup.vue';
import Button from '../Layout/Button.vue';

export default {
  components: {
    ButtonGroup,
    Button,
  },
  props: ['dietTypes'],
  data() {
    return {};
  },
  computed: {},
  // props: {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/mixins';

.ace-feed-step-1 {
  max-width: 680px;
  &__title {
    @include title;
  }
  &__buttons {
    margin-top: 55px;
  }
}
</style>
